<template>
  <v-app class="mt-0" id="inspire">
    <v-navigation-drawer
      fixed
      clipped
      :style="$vuetify.breakpoint.mdAndUp ? 'padding-top:96px' : 'padding-top:128px'"
      temporary
      enable-resize-watcher
      v-model="drawer"
      :disable-route-watcher="false"
    >
      <v-list class="pt-0">
        <template>
          <!-- <v-list-tile class="grey lighten-4 ">
          <v-list-tile-action>
            <v-btn icon @click.stop = "sideNav = false" >
              <v-icon>close</v-icon>
            </v-btn>
            </v-list-tile-action>
      <v-list-tile-content>
            <v-list-tile-title > <p style="font-size:24px;">LOGO</p></v-list-tile-title>
          </v-list-tile-content>
          </v-list-tile>-->
          <v-divider></v-divider>
          <v-list-tile v-for="item in main" :key="item.title" :to="item.link">
            <v-list-tile-action v-bind:class="isRightPath(item) ? '' : 'list-tile-action'">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content
              v-bind:class="isRightPath(item) ? '' : 'list-tile-content'"
            >{{ item.title }}</v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile v-for="item in content" :key="item.title" :to="item.link">
            <v-list-tile-action v-bind:class="isRightPath(item) ? '' : 'list-tile-action'">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content
              v-bind:class="isRightPath(item) ? '' : 'list-tile-content'"
            >{{ item.title }}</v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile v-for="item in info" :key="item.title" :to="item.link">
            <v-list-tile-action v-bind:class="isRightPath(item) ? '' : 'list-tile-action'">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content
              v-bind:class="isRightPath(item) ? '' : 'list-tile-content'"
            >{{ item.title }}</v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <v-spacer></v-spacer>

      <!-- <v-layout row wrap style="bottom:0px; position:absolute; width:100%">
        <v-flex xs12>
          <v-layout>
         <v-list-tile-sub-title class="pl-3" style="height:30px"> {{gLang[lang].layout.language}} </v-list-tile-sub-title>
          
        </v-layout>
        </v-flex>

        <v-flex xs12>
          <v-layout>
          <v-select class="pt-0 pl-3 pr-3 "
          @change="changeLang($event)"
         
          :items="items"
          v-model="lang"
          label="Select"
          single-line
          item-text="state"
          item-value="abbr"
          return-object
        ></v-select>

        </v-layout>
        </v-flex>
        
        
        
      </v-layout>-->
    </v-navigation-drawer>

    <v-toolbar
      class="menuToolbar"
      color="#F7F5E8"
      light
      app
      :extended="!$vuetify.breakpoint.smAndUp"
      flat
      clipped-left
      :height="$vuetify.breakpoint.smAndUp ? '76px':'64px'"
      fixed
      style="z-index:9999;
      "
    >
      <v-toolbar-side-icon class="ml-4" v-if="drawer" @click.stop="drawer = !drawer">
        <v-icon>close</v-icon>
      </v-toolbar-side-icon>
      <v-toolbar-side-icon class="ml-4" v-else @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <transition name="slide">
        <div
          v-if="searchMobile"
          style="width:90vw;margin-left:5vw;position:absolute;z-index:999999"
          class="hidden-sm-and-up"
        >
          <v-text-field
            light
            solo
            v-model="term"
            prepend-icon="search"
            :placeholder="gLang[lang].layout.search"
            append-icon="keyboard_arrow_up"
            :append-icon-cb="searchChange"
          ></v-text-field>
        </div>
      </transition>
      <v-spacer></v-spacer>
      <v-toolbar-title
        :style="$vuetify.breakpoint.smAndUp ? 'width: 300px; min-width: 250px' : 'min-width: 72px'"
        class="ml-0 pl-3 hidden-xs-only"
      >
        <router-link class="hidden-xs-only" to="/" tag="span" style="cursor: pointer">HERA</router-link>
      </v-toolbar-title>

      <!-- <img  v-if="$vuetify.breakpoint.mdAndUp " src="./assets/logo1.png" alt="" class="miniLogo"> -->
      <img
        v-if="$vuetify.breakpoint.mdAndUp "
        :style="$vuetify.breakpoint.smAndUp ? 'height:86px':'74px'"
        src="./assets/logo2.png"
        alt
        class="miniLogo2"
      >

      <v-layout
        justify-center
        v-if="!$vuetify.breakpoint.mdAndUp "
        slot="extension"
        class="white--text"
        style="    margin-left: 0px;   margin-right: 0px;"
      >
        <img
          src="./assets/logo2.png"
          alt
          :style="$vuetify.breakpoint.smAndUp ? 'height:86px':'74px'"
          class="miniLogo2"
        >
      </v-layout>

      <web-search-global
        :term="term"
        @success="closeSearch()"
        class="hidden-xs-only pt-2 pl-0 pr-5"
      ></web-search-global>

      <v-spacer class="hidden-xs-only"></v-spacer>
      <v-btn flat icon @click="searchMobile=true" class="hidden-sm-and-up mt-3 mr-0">
        <v-icon>search</v-icon>
      </v-btn>
      <v-toolbar-items class>
        <v-layout class="hidden-md-and-up ml-3" style="width:62px;">
          <v-select
            light
            class="pt-0 mt-3"
            @change="changeLang($event)"
            append-icon="arrow_drop_down"
            :items="items"
            v-model="lang"
            label="Select"
            single-line
            item-text="maj"
            item-value="abbr"
            return-object
          ></v-select>
        </v-layout>

        <v-layout class="hidden-sm-and-down" style="width:130px;">
          <v-select
            light
            class="pt-0 mt-3 pr-3"
            @change="changeLang($event)"
            append-icon="arrow_drop_down"
            :items="items"
            v-model="lang"
            label="Select"
            single-line
            item-text="state"
            item-value="abbr"
            return-object
          ></v-select>
        </v-layout>

        <!-- <v-icon dark style="cursor:pointer; padding-right:10px">search</v-icon> -->
        <div v-if="isAdmin || isMod || isLoggedIn" :class="{'hidden-sm-and-down':isAdmin}">
          <v-menu fixed>
            <v-btn icon class="mt-3" slot="activator">
              <v-icon>apps</v-icon>
            </v-btn>

            <v-list>
              <v-spacer>
                <!-- <v-btn flat fab small absolute slot="activator" style="top:10px;right:30px">? </v-btn> -->
              </v-spacer>
              <span v-if="isAdmin">
                <v-subheader>Add</v-subheader>
                <v-list-tile @click="toAddArtefact()" class="profilePopUpTiles">
                  <v-list-tile-action>
                    <v-icon>view_carousel</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class="profilePopUp">{{gLang[lang].layout.addartefact}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="toManageTags()" class="profilePopUpTiles">
                  <v-list-tile-action>
                    <v-icon>view_day</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class="profilePopUp">{{gLang[lang].layout.managetags}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="toManageGroups()" class="profilePopUpTiles">
                  <v-list-tile-action>
                    <v-icon>view_column</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class="profilePopUp">{{gLang[lang].layout.managegroups}}</v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>
              </span>
              <span v-if="isMod || isAdmin">
                <v-subheader>Tasks</v-subheader>

                <v-list-tile @click="toTasks()" class="profilePopUpTiles">
                  <v-list-tile-action>
                    <v-badge class="badge" flat color="indigo" v-model="show">
                      <span
                        v-if="unreviewedArtefacts.length > 0 || toBeDeleted.length > 0 || requests > 0"
                        slot="badge"
                      >{{getTaskNumber()}}</span>

                      <v-icon>view_list</v-icon>
                    </v-badge>
                  </v-list-tile-action>
                  <v-list-tile-content class="profilePopUp">{{gLang[lang].layout.tasks}}</v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
              </span>
              <v-subheader>More</v-subheader>
              <span v-if="isAdmin">
                <v-list-tile @click="toUsers()" class="profilePopUpTiles">
                  <v-list-tile-action>
                    <v-icon>contacts</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class="profilePopUp">{{gLang[lang].layout.users}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="toSettings()" class="profilePopUpTiles">
                  <v-list-tile-action>
                    <v-icon>settings</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class="profilePopUp">{{gLang[lang].layout.settings}}</v-list-tile-content>
                </v-list-tile>
              </span>
              <v-list-tile @click="toMessaging()" class="profilePopUpTiles">
                <v-list-tile-action>
                  <v-icon>chat</v-icon>
                </v-list-tile-action>
                <v-list-tile-content class="profilePopUp">{{gLang[lang].layout.messaging}}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile @click class="profilePopUpTiles">
                <v-list-tile-action>
                  <span
                    style="    padding-left: 7px;
    font-weight: bolder;
    font-size: 24px;
        color: rgba(0,0,0,0.54);"
                  >?</span>
                </v-list-tile-action>
                <v-list-tile-content class="profilePopUp">Download Manual</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>

        <div v-if="isLoggedIn">
          <v-menu fixed>
            <v-btn icon class="mt-3" slot="activator">
              <v-avatar size="35px" v-if="user != null && user.picture">
                <img v-if="user.picture.url" :src="user.picture.url+'_profile'" alt="avatar">
                <img v-else :src="user.picture" alt="avatar">
              </v-avatar>

              <v-icon v-else>account_circle</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile avatar>
                <v-list-tile-avatar v-if="user.picture">
                  <img v-if="user.picture.url" :src="user.picture.url" alt="avatar">
                  <img v-else :src="user.picture" alt="avatar">
                </v-list-tile-avatar>
                <v-list-tile-avatar v-else>
                  <v-icon>account_circle</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{user.displayName}}</v-list-tile-title>
                  <v-list-tile-sub-title v-if="user.email">{{user.email}}</v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    v-else
                    v-html=" '  <span class=\'grey--text text--lighten-1\'> Connected with: ' + provider(user) + '</span>' "
                  ></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon to="/account/">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>

            <v-list>
              <v-divider></v-divider>

              <v-list-tile class="profilePopUpTiles">
                <v-list-tile-content
                  class="profilePopUp"
                  @click="toAccount()"
                >{{gLang[lang].layout.myaccount}}</v-list-tile-content>
              </v-list-tile>

              <v-list-tile class="profilePopUpTiles">
                <v-list-tile-content
                  class="profilePopUp"
                  @click="upgradeDialog = true"
                >{{gLang[lang].myAccount.iWantToContribute}}</v-list-tile-content>
              </v-list-tile>

              <v-divider></v-divider>
              <v-list-tile class="profilePopUpTiles">
                <v-list-tile-content
                  class="profilePopUp"
                  @click="logOut"
                >{{gLang[lang].layout.logout}}</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <div v-else>
          <v-btn flat class="mt-3" to="/signin">{{gLang[lang].signIn.signIn}}</v-btn>
        </div>
      </v-toolbar-items>
    </v-toolbar>

    <web-search-global
      v-if="term"
      :term="term"
      @success="closeSearch()"
      class="hidden-sm-and-up mt-5"
      style="position:absolute; z-index:999"
    ></web-search-global>

    <v-content class="pt-0 mt-0">
      <main
        class="mb-5"
        :style="$vuetify.breakpoint.sm ? 'margin-top:196px; min-height:90vh; margin-bottom:192px;'  : $vuetify.breakpoint.xs ?'margin-top:128px; min-height:90vh; margin-bottom:192px;' : 'margin-top:76px; min-height:90vh'"
        app
        light
      >
        <router-view></router-view>
      </main>

      <v-footer
        class="pa-3 mt-5 text-xs-center"
        style="border-top:1px solid #efefef; background-color:#FAFAFA;    position: relative;
    bottom: 0px;
    left: 0px;
    width: 100vw;
"
      >
        <!-- <div> </div> <br>
    
    <div >

        </div>-->
        <v-layout justify-center row wrap style="width:100%">
          <v-flex xs12 md3>
            <img src="./assets/logo1.png" style="height:85px" class="miniLogo1Footer">
          </v-flex>

          <v-flex xs12 md3>
            <div>
              <p>
                <strong v-if="lang == 'en'">Cooperation beyond borders.</strong>
                <strong v-if="lang == 'ro'">Cooperare dincolo de frontiere.</strong>
                <strong v-if="lang == 'sr'">Saradnja preko granica!</strong>
              </p>
              <p
                v-if="lang == 'en'"
              >Interreg-IPA Cross-border Cooperation Romania-Serbia Programme is financed by the European Union under the Instrument for Pre-accession Assistance (IPA II) and co-financed by the partner states in the Programme.</p>
              <p
                v-if="lang == 'ro'"
              >Programul INTERREG IPA de Cooperare Transfrontalieră Romania-Serbia este finanțat de Uniunea Europeană prin Instrumentul de Asistenţă pentru Preaderare (IPA II) şi cofinanţat de statele partenere în program.</p>
              <p
                v-if="lang == 'sr'"
              >INTEREG IPA Program prekogranične saradnje Rumunija – Srbija je finansiran od strane Evropske unije u okviru instrumenta za pretpristupnu pomoć (IPA II) i sufinansiran od strane država učesnica programa.</p>
            </div>
            <p class="ma-0" style=" ">{{ new Date().getFullYear() }} © HERA</p>
            <a href="/api/download_apk">Get Mobile Application</a>
          </v-flex>
          <v-flex xs12 md3 :style="!$vuetify.breakpoint.mdAndUp? 'margin-top:25px':''">
            <img src="./assets/Layer1.png" style="height:85px" class="miniLogo2Footer">
          </v-flex>

          <v-flex xs12>
            <div v-if="isAdmin" row class="hidden-md-and-up" style="height:60px; width:100%"></div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-content>

    <!-- <v-speed-dial id="bottom_button" class="app-vue-speeddial" v-if="!isAdmin && isLoggedIn"
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :hover="hover"
      :transition="transition"
      fixed
    >
      <v-btn class="ma-1"
        slot="activator"
        color="blue darken-2"
        dark
        fab
        hover
        v-model="fab"
        to='/artefacts/new'
      >
        <v-icon>add</v-icon>
        
      </v-btn>

    </v-speed-dial>-->
    <v-bottom-nav
      class="hidden-md-and-up"
      white
      v-if="isAdmin"
      :value="true"
      :active.sync="e1"
      color="white"
      style="background:white; margin-top:60px;"
    >
      <!-- <v-flex xs4>

    <v-menu id="moreMenu"
        origin="center center"
        transition="scale-transition"
        bottom
      >
        <v-btn color="primary" light slot="activator">
          <span>More</span>
        <v-icon>swap_vertical_circle</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="item in more" :key="item.title" :to="item.link">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      </v-flex>-->
      <v-flex xs4 class="text-xs-center">
        <v-bottom-sheet temporary v-model="sheet">
          <v-btn color="primary" light slot="activator">
            <span>More</span>
            <v-icon>swap_vertical_circle</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="tile in more"
              :key="tile.title"
              @click="sheet = false"
              :to="tile.link"
            >
              <v-list-tile-avatar>
                <v-avatar size="32px" tile>
                  <v-icon>{{tile.icon}}</v-icon>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ tile.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-bottom-sheet>
      </v-flex>

      <v-flex xs4 class="text-xs-center">
        <v-bottom-sheet temporary v-model="sheet2">
          <v-btn color="primary" light slot="activator">
            <span>Add</span>
            <v-icon>add_circle</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="tile in add"
              :key="tile.title"
              @click="sheet2 = false"
              :to="tile.link"
            >
              <v-list-tile-avatar>
                <v-avatar size="32px" tile>
                  <v-icon>{{tile.icon}}</v-icon>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ tile.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-bottom-sheet>
      </v-flex>

      <!-- <v-flex xs4>

      <v-menu id="addMenu"
        origin="center center"
        transition="scale-transition"
        bottom
      >
        <v-btn color="primary" light slot="activator">
        <span>Add</span>
        <v-icon>add_circle</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="item in add" :key="item.title" :to="item.link">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      


      </v-flex>-->
      <v-flex xs4 class="text-xs-center">
        <v-btn @click.native="show = false" flat color="black" value="nearby" to="/tasks">
          <div class="btn_tasks">
            <v-badge class="badge" flat color="indigo" v-model="show">
              <span
                v-if="unreviewedArtefacts.length > 0 || toBeDeleted.length > 0 || requests > 0"
                slot="badge"
              >{{unreviewedArtefacts.length+toBeDeleted.length+requests}}</span>

              <v-icon>view_list</v-icon>
            </v-badge>
            <span class="tasks">{{gLang[lang].layout.tasks}}</span>
          </div>
        </v-btn>
      </v-flex>
    </v-bottom-nav>

    <v-dialog v-model="upgradeDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-layout row class="pa-3">
          <v-select
            :items="items1"
            v-model="select1"
            label="Select"
            class="input-group--focused"
            item-value="text"
          ></v-select>
        </v-layout>

        <v-layout row class="pa-3">
          <p v-if="select1 == 'Contributor'">{{gLang[lang].myAccount.contributorRights}}</p>
          <p v-else-if="select1 == 'Moderator'">{{gLang[lang].myAccount.moderatorRights}}</p>
          <p v-else-if="select1 == 'Admin'">{{gLang[lang].myAccount.adminRights}}</p>
        </v-layout>

        <v-card-actions class="pa-3">
          <v-layout row>
            <v-btn color="primary" @click="sendMessage()">{{gLang[lang].myAccount.sendRequest}}</v-btn>
            <v-btn
              color="primary"
              flat
              @click.stop="upgradeDialog=false"
            >{{gLang[lang].myAccount.close}}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :timeout="timeout"
      :color="colorS"
      :multi-line="mode"
      :vertical="!mode"
      v-model="showSucces"
    >
      {{gLang[lang].myAccount.successMessage}}
      <v-btn dark flat @click.native="showSucces = false">{{gLang[lang].myAccount.close}}</v-btn>
    </v-snackbar>

    <v-snackbar
      :timeout="timeout"
      :color="colorF"
      :multi-line="mode"
      :vertical="!mode"
      v-model="showFail"
    >
      {{gLang[lang].myAccount.failMessage}}
      <v-btn dark flat @click.native="showFail = false">{{gLang[lang].myAccount.close}}</v-btn>
    </v-snackbar>

    <v-snackbar
      :timeout="timeout"
      :color="colorF"
      :multi-line="mode"
      :vertical="!mode"
      v-model="showFailAlreadyRequested"
    >You already have a pending role change request, please wait for review or contact administration!
      <v-btn
        dark
        flat
        @click.native="showFailAlreadyRequested = false"
      >{{gLang[lang].myAccount.close}}</v-btn>
    </v-snackbar>

    <v-snackbar
      :timeout="timeout"
      :color="colorF"
      :multi-line="mode"
      :vertical="!mode"
      v-model="showFailRoleAlready"
    >You already have the role you are trying to request!
      <v-btn dark flat @click.native="showFailRoleAlready = false">{{gLang[lang].myAccount.close}}</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      requests: 0,
      select1: "Contributor",
      items1: [
        { text: "Contributor" },
        { text: "Moderator" },
        { text: "Admin" }
      ],
      upgradeDialog: false,
      searchMobile: false,
      dialog: false,
      showFailAlreadyRequested: false,
      showFailRoleAlready: false,
      timeout: 6000,
      colorS: "info",
      colorF: "red",
      mode: true,
      showSucces: false,
      showFail: false,
      term: "",
      drawer: null,
      items: [
        {
          icon: "bubble_chart",
          title: "Home",
          link: "/home",
          withoutAuth: true
        },
        {
          icon: "place",
          title: "Map",
          link: "/map",
          withoutAuth: true
        },
        {
          icon: "list",
          title: "Issues",
          link: "/issues",
          withoutAuth: true
        },
        {
          icon: "track_changes",
          title: "Statistics",
          link: "/statistics",
          withoutAuth: true
        },
        {
          icon: "perm_identity",
          title: "Profile",
          link: "/profile",
          withoutAuth: false
        }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "iCare",
      e1: "recent",
      show: true,
      badgeData: { value: "!" },

      sheet: false,

      sheet2: false,

      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      appear: false,
      temp: true,
      transitionName: "slide-left",
      select: { state: "English", abbr: "en", maj: "EN" },
      items: [
        { state: "English", abbr: "en", maj: "EN" },
        { state: "Romana", abbr: "ro", maj: "RO" },
        { state: "Српски", abbr: "sr", maj: "SR" }
      ]
    };
  },
  watch: {
    // $route(to, from) {
    //   const toDepth = to.path.split("/").length;
    //   const fromDepth = from.path.split("/").length;
    //   //this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
    // }
  },
  methods: {
    closeSearch() {
      this.searchMobile = false;
      this.term = "";
    },
    getTaskNumber() {
      if (this.isAdmin)
        return (
          this.unreviewedArtefacts.length +
          this.toBeDeleted.length +
          this.requests
        );
      else return this.unreviewedArtefacts.length + this.toBeDeleted.length;
    },
    loadRequests() {
      if (this.isAdmin)
        axios.get("/api/requests").then(response => {
          this.requests = response.data.length;
        });
    },
    sendMessage() {
      if (this.select1 == this.user.role) {
        this.showFailRoleAlready = true;
        this.upgradeDialog = false;
      } else {
        axios
          .post("/api/requests", { user: this.user, role: this.select1 })
          .then(response => {
            this.showSucces = true;
            this.upgradeDialog = false;
          })
          .catch(err => {
            if (err.response.status == 409) {
              this.showFailAlreadyRequested = true;
              this.upgradeDialog = false;
            } else {
              this.showFail = true;
              this.upgradeDialog = false;
            }
          });
      }

      // var concatMessage =
      //   this.user.displayName +
      //   " requests rights for the role: \n" +
      //   this.select +
      //   " \n";
      // axios
      //   .post("/api/messages/email", {
      //     message: concatMessage,
      //     email: "hera.restore@gmail.com"
      //   })
      //   .then(response => {
      // this.showSucces = true;
      // this.upgradeDialog = false;
      //   })
      //   .catch(err => {
      // this.showFail = true;
      // this.upgradeDialog = false;
      //   });
    },
    changeLang(lang) {
      this.$store.dispatch("changeLang", lang.abbr);
    },
    searchChange() {
      this.searchMobile = false;
      this.term = "";
    },
    logOut() {
      this.$auth.logout();
      this.$store.dispatch("logOut");
      this.$router.push("/");
    },
    isRightPath(item) {
      if (this.$route.path == item.link) {
        return true;
      } else return false;
    },
    temporaryDrawer() {
      if (screen.width > 960) this.temp = false;
      else this.temp = true;
    },
    toAccount() {
      this.$router.push("/account/");
    },
    toAddArtefact() {
      this.$router.push("/artefacts/new/");
    },
    toManageTags() {
      this.$router.push("/collections/new/");
    },
    toManageGroups() {
      this.$router.push("/groups/new/");
    },
    toTasks() {
      this.$router.push("/tasks/");
    },
    toUsers() {
      this.$router.push("/users/");
    },
    toSettings() {
      this.$router.push("/settings/");
    },
    toMessaging() {
      this.$router.push("/messaging/");
    },
    provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";
      else if (user.hasOwnProperty("google")) return "Google";
      else if (user.hasOwnProperty("live")) return "Microsoft Live";
      else return "Local Register";
    }
    // appearButton(appear) {
    //   var btn = document.getElementById('bottom_button');

    //   if (this.$route.path == '/artefacts/new' || this.$route.path == '/login')
    //       appear = false;
    //   else
    //       appear = true;

    //       console.log(this.$route.path);
    //       console.log(appear);

    // },
    // moveButton(admin) {
    //   var btn = document.getElementById('bottom_button');
    //   if(admin) {

    //     btn.style.bottom = '65px';

    //   }
    //   else
    //   {

    //     btn.style.bottom = '15px';
    //   }

    // }
  },
  computed: {
    toBeDeleted() {
      return this.$store.getters.loadToBeDeletedArtefacts;
    },
    add() {
      return [
        {
          icon: "view_carousel",
          title: this.gLang[this.lang].layout.addartefact,
          link: "/artefacts/new"
        },
        {
          icon: "view_day",
          title: this.gLang[this.lang].layout.managetags,
          link: "/collections/new"
        },
        {
          icon: "view_column",
          title: this.gLang[this.lang].layout.managegroups,
          link: "/groups/new"
        }
      ];
    },
    more() {
      return [
        {
          icon: "contacts",
          title: this.gLang[this.lang].layout.users,
          link: "/users"
        },
        {
          icon: "chat",
          title: this.gLang[this.lang].layout.messaging,
          link: "/messaging"
        },
        {
          icon: "settings",
          title: this.gLang[this.lang].layout.settings,
          link: "/settings"
        }
      ];
    },
    info() {
      return [
        {
          icon: "message",
          title: this.gLang[this.lang].contact.title.slice(
            0,
            this.gLang[this.lang].contact.title.length - 1
          ),
          link: "/contact"
        },
        {
          icon: "info",
          title: this.gLang[this.lang].layout.about,
          link: "/about"
        },
        {
          icon: "link",
          title: this.gLang[this.lang].layout.link || "Links",
          link: "/links"
        },
        {
          icon: "feedback",
          title: this.gLang[this.lang].layout.termsconditions,
          link: "/terms-and-conditions"
        }
      ];
    },
    content() {
      return [
        {
          icon: "view_carousel",
          title: this.gLang[this.lang].layout.artefacts,
          link: "/artefacts"
        },
        {
          icon: "view_day",
          title: this.gLang[this.lang].layout.collections,
          link: "/collections"
        },
        {
          icon: "view_column",
          title: this.gLang[this.lang].layout.groups,
          link: "/group-collections"
        }
      ];
    },
    main() {
      return [
        { icon: "home", title: this.gLang[this.lang].layout.home, link: "/" },
        {
          icon: "local_library",
          title: this.gLang[this.lang].layout.explore,
          link: "/explore"
        }
      ];
    },
    gLang() {
      return this.$store.getters.loadGlobLang;
    },
    lang() {
      return this.$store.getters.loadLang;
    },
    badge() {
      return this.show ? this.badgeData : null;
    },
    token() {
      return this.$store.getters.getToken;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod() {
      return this.$store.getters.isMod;
    },
    isContrib() {
      return this.$store.getters.isContrib;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    user() {
      if (this.isLoggedIn) return this.$store.getters.getUser;
      else return null;
    },
    unreviewedArtefacts() {
      return this.$store.getters.loadUnreviewedArtefacts;
    }
  },
  mounted() {
    if (this.$store.getters.getToken && this.$store.getters.getToken != "") {
    } else {
      if (this.$store.getters.getIdentifier == "")
        this.$store.dispatch("setUserIdentifier");
    }
    // this.moveButton(this.isAdmin);
    //this.appearButton(this.appear);
    this.temporaryDrawer();
    window.scrollTo(0, 0);
  },
  created() {
    this.loadRequests();
    this.$store.dispatch("updateCurrentUser", { token: this.token });
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
    this.$store.dispatch("loadLanguages");
  }
};
</script>

<style>
.tooltip {
  color: darkgray;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 99999;
}
@media screen and (min-width: 960px) {
  .menuToolbar .toolbar__content {
    -webkit-box-shadow: 1px 5px 5px -5px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 1px 5px 5px -5px rgba(0, 0, 0, 0.75);
    box-shadow: 1px 5px 5px -5px rgba(0, 0, 0, 0.75);
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.7s ease;
  opacity: 1;
}
.slide-fade-enter {
  transform: translateY(-10px);
  opacity: 0.3;
}

.slide-enter-active {
  transition: all 0.3s ease;
}
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.badge__badge {
  position: absolute;
  font-size: 11px;
  top: -4px;
  right: -9px;
  border-radius: 50%;
  height: 16px;
  line-height: 22px;
  width: 16px;
}

.tasks {
  position: absolute;
  top: 22px;
  right: -5px;
}

.btn_tasks {
  position: absolute;
  bottom: 24px;
}

.menu {
  display: block !important;
}

#moreMenu,
#addMenu {
  /* top: 431px !important; */
}
.margin_bot {
  padding-bottom: 60px;
}

.list-tile-action {
  color: rgba(0, 0, 0, 0.54);
}

.list-tile-content {
  color: rgba(0, 0, 0, 0.8);
}

.profilePopUpTiles {
  text-align: left;
  height: 50px;
}

.profilePopUpTiles:hover {
  background-color: #efefef;
}

.miniLogo {
  height: 50px;
}

.miniLogo2 {
  height: 74px;
  margin-left: 8px;
}
</style>







// WEBPACK FOOTER //
// src/App.vue